import { PolicesDetailClass } from './ageas-class';
import { Icon } from './common-class';
import { FilesClass } from './uploads-class';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(utc);
dayjs.extend(customParseFormat);

export class InsurancePolicyClass {
  idInsurancePolicy?: number | null = null;
  idCustomer?: number | null = null;
  NIF: string = '';
  CustomerName: string = '';
  idCompanie?: number | null = null;
  CompanieName: string = '';
  CompaniesShortName: string = '';
  CompaniesIcon: Icon | null = null;
  idProduct?: number | null = null;
  ProductName: string = '';
  ProductShortName: string = '';
  idProductsTypes: number | null = null;
  ProductsTypesName: string = '';
  ProductsTypesShortName: string = '';
  idPaymentsTypes: number | null = null;
  idPaymentsSplit?: number | null = null;
  PaymentsSplitDescription: string = '';
  idInsurancePolicyStatusTypes?: number | null = null;
  InsurancePolicyStatusTypesDescription: string = '';
  InsurancePolicyStatusTypesBackground: string = '';
  InsurancePolicyStatusTypesTextColor: string = '';
  InsurancePolicyStatusTypesCanceled: boolean = false;
  Canceled: boolean = false;
  IconURLStatus: string = '';
  ProductsIcon: Image | null = null;
  idCommercial?: number | null = null;
  CommercialName: string = '';
  idBillingAddress: number | null = null;
  idShipToAddress: number | null = null;
  idMediator: number | null = null;
  AddressDetail: string = '';
  PostalCode: string = '';
  Region: string = '';

  PolicyNumber: string = '';
  Description: string = '';
  Matricula: string = '';
  MatriculaDados: string = '';
  Capital: number | null = null;
  Salario: number | null = null;
  CreatedByUser?: number | null = null;
  AllowMediatorEdit: boolean = false;
  DateStartPolicy: Date | null = null;
  DateEndPolicy: Date | null = null;
  renewalDate: Date | null = null;
  NIB: string = '';
  Price: number | null = null;
  AcceptContract: boolean = false;
  AcceptRGPD: boolean = false;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  ReceiveAlerts: boolean = false;
  Newsletter: boolean = false;
  GestaoEmailWhatsAp: boolean = false;
  AceitoTransferenciaSeguro: boolean = false;
  DataSource: string = '';
  SendSMS: boolean = false;
  SendSMSDays: number | null = null;

  SendWhatsApp: boolean = false;
  SendWhatsAppDays: number | null = null;

  SendEmail: boolean = false;
  SendEmailDays: number | null = null;

  SendSMSInspecAuto: boolean = false;
  SendSMSDaysInspecAuto: number | null = null;
  SendEmailInspecAuto: boolean = false;
  SendEmailDaysInspecAuto: number | null = null;

  SendWhatsAppInspecAuto: boolean = false;
  SendWhatsAppDaysInspecAuto: number | null = null;

  Signature: string = '';
  UUID: string = '';
  insurancePolicyFilesClass: FilesClass[] = [];
  UUIDLastChange: string = '';
  TitleForm: string = '';

  files: number | null = null;
  ManagedBySegurosVirtual: boolean = false;

  ShowMatricula: boolean = false;
  ShowCapital: boolean = false;
  ShowSalario: boolean = false;
  isProduct: boolean = false;
  ShowCarInspection: boolean = false;
  ShowInsuranceClaimsCausesTypes: boolean = false;
  isHealthInsurance: boolean = false;
  Order: number | null = null;
  AGEASDetail: PolicesDetailClass | null = null;
  loading: boolean = false;

  marca: string = '';
  modelo: string = '';
  versao: string = '';
  commercialPremium: number | null = null;
  premiumCharged: number | null = null;
  premiumIssuedThisYearAndPayed: number | null = null;

  public parseDates() {
    const dateFields = ['DateStartPolicy', 'DateEndPolicy', 'renewalDate', 'DateStart', 'DateEnd'];

    dateFields.forEach(f => {
      if (this[f] && (typeof this[f] === 'string' || this[f] instanceof Date)) {
        const val = this[f];
        // 1. Tentar parse genérico (ISO 8601, etc)
        let d = dayjs.utc(val);

        // 2. Se falhar e for string, tentar formatos comuns de input manual em Portugal
        if (!d.isValid() && typeof val === 'string') {
          const formats = ['DDMMYYYY', 'DD-MM-YYYY', 'DD-MM-YYYY'];
          for (const format of formats) {
            const dManual = dayjs.utc(val, format, true); // strict = true
            if (dManual.isValid()) {
              d = dManual;
              break;
            }
          }
        }

        if (d.isValid()) {
          this[f] = d.startOf('day').toDate();
        }
      } else if (this[f] && dayjs.isDayjs(this[f])) {
        this[f] = (this[f] as any).utc().startOf('day').toDate();
      }
    });
  }
}

export class InsurancePolicyReceipts {
  idInsurancePolicyReceipts: number | null = null;
  idInsurancePolicy: number | null = null;
  idCustomer: number | null = null;
  idCompanie: number | null = null;
  PolicyNumber: string = '';
  idProduct: number | null = null;
  idProductsTypes: number | null = null;
  receiptNumber: string = '';
  receiptNumberAlias: string = '';
  typeNatureId: string = '';
  typeNatureDescription: string = '';
  agentCollectorId: string = '';
  bankCircuit: string = '';
  emissionDate: string = '';
  premium: number | null = null;
  paymentChannelId: string = '';
  paymentChannelDescription: string = '';
  agentMediatorId: string = '';
  situationDate: string = '';
  premiumTax: number | null = null;
  commission: number | null = null;
  DateStart: string = '';
  DateEnd: string = '';
  DataSource: string = '';
  nif: string = '';
  lobDescription: string = '';
  clientName: string = '';
  amountReceipt: number | null = null;
  antique: number | null = null;
  startDate: string = '';
  maturityDate: string = '';
  paymentDueDate: string = '';
  situationId: string = '';
  situationDescription: string = '';
  methodsPaymentId: string = '';
  methodsPaymentDescription: string = '';
  company: string = '';

  DocumentName: string = '';
  Description: string = '';
  updated: Date | null = null;
  FilePath: string = '';
  type: string = '';
  size: number | null = null;
  ManagedBySegurosVirtual: boolean = false;
  AGEASDetail: any = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class InsurancePolicyMessages {
  idInsurancePolicyMessage: number | null = null;
  idInsurancePolicy?: number | null = null;
  Subject: string = '';
  Text: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  idInsuranceClaimsMessageOwner: number | null = null;
  fromidCommercial: number | null = null;
  toidCommercial: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';

  insurancePolicyMessagesFiles: InsurancePolicyMessagesFiles[] = [];
}

export class InsurancePolicyMessagesFiles {
  idInsurancePolicyMessageFiles: number | null = null;
  idInsurancePolicyMessage: number | null = null;
  subjectfile: string = '';
  DocumentName: string = '';
  updated: Date | null = null;
  FilePath: string = '';
  type: string = '';
  size: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class InsurancePolicyStatusTypesClass {
  idInsurancePolicyStatusTypes: number | null = null;
  Description: string = '';
  Background: string = '';
  TextColor: string = '';
  Icon: Image | null = null;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Default: number | null = null;
  Payment: number | null = null;
  Order: number | null = null;
  idAGEAS: string = '';
  idTranquilidade: string = '';
  SabSeg: string = '';
  UUID: string = '';
  UUIDLastChange: string = '';
}

export class Image {
  type: string = '';
  data: number[] = [];
}

export class InsurancePolicyExportClass {
  Cliente: string = '';
  Companhia: string = '';
  Seguro: string = '';
  Produto: string = '';
  Fracionamento: string = '';
  Estado: string = '';
  Apolice: string = '';
  Descritivo: string = '';
  Matricula: string = '';
  Capital: number | null = null;
  Salario: number | null = null;
  DataInicioApolice: Date | null = null;
  DataFimApolice: Date | null = null;
  NIB: string = '';
  Valor: number | null = null;
}

export class ASFMatricula {
  ErroDeValidacoes: string = '';
  Matricula: string = '';
  Entidade: string = '';
  DataInicio: string = '';
  DataFim: string = '';
  Apolice: string = '';
  Pais: string = '';
}

export class InsurancePolicyRisks {
  idInsurancePolicyRisks: number | null = null;
  idInsurancePolicy: number | null = null;
  idCustomer: number | null = null;
  idCompanie: number | null = null;
  PolicyNumber: string = '';
  LinhaNegocio: string = '';
  LinhaNegocioDesc: string = '';
  produto: string = '';
  NrObjeto: string = '';
  TipoObjeto: string = '';
  TipoObjetoDesc: string = '';
  NrPessoaSegura: string = '';
  NomePessoaSegura: string = '';
  Matricula: string = '';
  DtMatricula: string = '';
  Categoria: string = '';
  CategoriaDesc: string = '';
  TipoMatricula: string = '';
  TipoMatriculaDesc: string = '';
  marca: string = '';
  modelo: string = '';
  versao: string = '';
  Combustivel: string = '';
  Cilindrada: string = '';
  PotenciaCV: number | string | null = null;
  PotenciaKW: number | string | null = null;
  Peso: string = '';
  NrLugares: string = '';
  VIN: string = '';
  PremioComercial: number | null = null;
  Capital: number | null = null;
  LocalRiscoMorada: string = '';
  LocalRiscoLocalidade: string = '';
  CodPostal: string = '';
  DtConstrucao: string = '';
  PercentagemIndexacao: number | null = null;
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  ManagedBySegurosVirtual: boolean | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
}

// Generated by https://quicktype.io

export class InsurancePolicyCompanyRequestsQuizClass {
  idInsurancePolicyCompanyRequestsQuizOwnerAnterior: number | null = null;
  idInsurancePolicyCompanyRequestsQuiz: number | null = null;
  idCompanie: number | null = null;
  idProduct: number | null = null;
  idProductsTypes: number | null = null;
  Description: string = '';
  comments: string = '';
  FontSize: number | null = null;
  FontWeight: string = '';
  TextColor: string = '';
  BackgroundColor: string = '';
  DateStart: Date | null = null;
  DateEnd: Date | null = null;
  Order: number | null = null;
  UUID: string = '';
  UUIDLastChange: string = '';
  idInsurancePolicyCompanyRequestsQuizOwner: number | null = null;
  Children: number | null = null;
}

export class AGEASInsurancePolicyDocument {
  documentId: string = '';
  documentName: string = '';
  date: string = '';
  type: {
    id: string | null;
    description: string | null;
  } = {
    id: null,
    description: null,
  };
}

export class InsurancePolicyRisksClass {
  idInsurancePolicyRisks: number | null = null;
  idInsurancePolicy: number | null = null;
  idCustomer: number | null = null;
  idCompanie: number | null = null;
  PolicyNumber: string = '';
  produto: string = '';
  NrObjeto: string = '';
  TipoObjeto: string = '';
  TipoObjetoDesc: string = '';
  NrPessoaSegura: string = '';
  NomePessoaSegura: string = '';
  Matricula: string = '';
  DtMatricula: string = '';
  Categoria: string = '';
  CategoriaDesc: string = '';
  TipoMatricula: string = '';
  TipoMatriculaDesc: string = '';
  marca: string = '';
  modelo: string = '';
  versao: string = '';
  Combustivel: string = '';
  Cilindrada: string = '';
  PotenciaCV: number | string | null = null;
  PotenciaKW: number | string | null = null;
  Peso: string = '';
  NrLugares: string = '';
  VIN: string = '';
  PremioComercial: number | null = null;
}

export class InsurancePolicyChartClass {
  idCompanie?: number | null = null;
  CompaniesShortName: string = '';
  idProduct?: number | null = null;
  ProductShortName: string = '';
  idProductsTypes: number | null = null;
  ProductsTypesShortName: string = '';
  Total: number = 0;
}
